import React, { useEffect, createRef, useState, Fragment, useContext } from 'react';
import { useSelector, connect } from 'react-redux';
import LocaleContext from 'constants/localization';
import Form from 'react-bootstrap/Form';
import API from 'constants/api';
import { setStatementComment } from 'actions/modalActions';

const StatementCommentModal= ({ resource, setStatementComment }) => {
  const LS = useContext(LocaleContext);
  const [comment,setComment] = useState(null);

  const inputRef = createRef();
  
  let onChange = e => setComment(e.target.value);
  
  const defaultProps = {
    onChange,
    ref: inputRef,
    onWheel: () => inputRef.current.blur() // SPEC-292 disable scroll
  };

  const sendComment = () => {
	setStatementComment(comment);
  }

  return (
    <div>
    	<Form.Control as="textarea" {...defaultProps} />
    	<br/>
    	<button
          className="send-comment" 
          type="button"
          onClick={sendComment}>
          <i class="fa fa-pencil-square-o"/> {LS.statement.sendComment}
        </button>
    </div>
  );
};

export default connect(null, { setStatementComment })(StatementCommentModal);